import React from 'react';
import { useNavigate } from 'react-router-dom';

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleTryForFree = () => {
    navigate('/select-account-type', { state: { isSignup: true } });
  };

  const handleSignIn = () => {
    navigate('/select-account-type', { state: { isSignup: false } });
  };

  return (
    <div className="welcome-page">
      <h1 className="welcome-title">Welcome to Smart storage</h1>
      <p className="welcome-description">
        Secure cloud backup and storage solution for businesses. 
        Ensure compliance, protect your data, and access your files from anywhere. 
        Professional-grade storage with enterprise security and reliability.
      </p>
      <div className="welcome-buttons">
        <button
          onClick={handleTryForFree}
          className="btn btn-primary"
          style={{
            backgroundColor: '#ffc107',
            background: '#ffc107',
            color: '#000',
            border: 'none',
            fontWeight: '600'
          }}
        >
          Try for Free
        </button>
        <button
          onClick={handleSignIn}
          className="btn btn-secondary"
        >
          Sign In
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;
